"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BytesT = exports.Bytes = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class Bytes {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsBytes(bb, obj) {
        return (obj || new Bytes()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsBytes(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Bytes()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    b(index) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    bLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    bArray() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    static startBytes(builder) {
        builder.startObject(1);
    }
    static addB(builder, bOffset) {
        builder.addFieldOffset(0, bOffset, 0);
    }
    static createBVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startBVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static endBytes(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createBytes(builder, bOffset) {
        Bytes.startBytes(builder);
        Bytes.addB(builder, bOffset);
        return Bytes.endBytes(builder);
    }
    unpack() {
        return new BytesT(this.bb.createScalarList(this.b.bind(this), this.bLength()));
    }
    unpackTo(_o) {
        _o.b = this.bb.createScalarList(this.b.bind(this), this.bLength());
    }
}
exports.Bytes = Bytes;
class BytesT {
    constructor(b = []) {
        this.b = b;
    }
    pack(builder) {
        const b = Bytes.createBVector(builder, this.b);
        return Bytes.createBytes(builder, b);
    }
}
exports.BytesT = BytesT;
